// @ts-nocheck

export const page = async () => {
    
    // moreData()

}

function moreData(){    
    let currentStep = 1
    const limitPagination = 5
    const books:NodeListOf<HTMLElement> = document.querySelectorAll('.allRanking')
    const btnAll = document.querySelector('.mxmhboxranking__content--moreData');
    console.log(books.length, limitPagination)
    if(books.length < limitPagination){
        btnAll.classList.add('hideBtn')
    }else{
        btnAll.classList.remove('hideBtn')
    }
    
    showPaginationByStep( currentStep )

    function showBooks( start:any, end:any ) {
        const filteredBooks = Array.from(books).map( (book, index) => {
            index >= start && index <= end ? book.classList.add('show') : '';
        } )
        if(books.length - 1 == end){
            btnAll.classList.add('hideBtn')
        }
    }
    function showPaginationByStep( step:any  ) {
        const filterStart = (limitPagination * ( step - 1) + 1)
        const filterEnd = limitPagination * step

        showBooks( filterStart - 1, filterEnd - 1)
    }
    btnAll.addEventListener('click', (e) => {
        currentStep++
        showPaginationByStep( currentStep )
    })
}